<script setup>
</script>

<template>
    <div class="time-loader">
        <div class="time-loader__item" v-for="i in 6" :key="i"></div>
    </div>
</template>